import React from 'react'
import ReactDOM from 'react-dom'

// These two containers are siblings in the DOM
const portalRoot = document.body

export default class Portal extends React.Component {
  private el: HTMLDivElement

  public constructor(props: any) {
    super(props)
    this.el = document.createElement('div')
  }

  public componentDidMount() {
    // The portal element is inserted in the DOM tree after
    // the Modal's children are mounted, meaning that children
    // will be mounted on a detached DOM node. If a child
    // component requires to be attached to the DOM tree
    // immediately when mounted, for example to measure a
    // DOM node, or uses 'autoFocus' in a descendant, add
    // state to Modal and only render the children when Modal
    // is inserted in the DOM tree.
    portalRoot.appendChild(this.el)
  }

  public componentWillUnmount() {
    portalRoot.removeChild(this.el)
  }

  public render() {
    return ReactDOM.createPortal(this.props.children, this.el)
  }
}
